var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isEmbed)?_c('div',{staticClass:"begin-play"},[_c('vh-tooltip',{directives:[{name:"tooltipMove",rawName:"v-tooltipMove"}],staticClass:"item",attrs:{"effect":"dark","content":"发起直播","placement":"top"}},[_c('div',{staticClass:"begin-btn",on:{"click":_vm.toRoom}},[_c('i',{staticClass:"iconfont-v3 saasicon_kaibo"})])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }